export default __webpack_public_path__ + "static/media/lenze_918_4.c78a77d9.jpg";